import React from 'react';
import PropTypes from 'prop-types';
import { fetchCriterionOptions } from '../services/options_services';
import InputAsyncInformed from './InputAsyncInformed';

const CriterionInputAsyncInformed = ({ params, ...props }) => (
  <InputAsyncInformed
    defaultOptions
    placeholder="Critério"
    loadOptions={(search) => fetchCriterionOptions({ search, ...params })}
    {...props}
  />
);

CriterionInputAsyncInformed.propTypes = {
  params: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.object])
  ),
};

CriterionInputAsyncInformed.defaultProps = {
  params: {},
};

export default CriterionInputAsyncInformed;
